/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationSaveCourseAccessRequestViewModel } from "../types/CourseRegistrationSaveCourseAccessRequestViewModel.ts";

export const courseRegistrationSaveCourseAccessRequestViewModelSchema =
  z.object({
    released: z.optional(
      z
        .boolean()
        .describe("Define se o acesso ao curso está liberado para o aluno."),
    ),
    releasedUntil: z
      .string()
      .datetime()
      .describe(
        "Data limite até a qual o acesso ao curso está liberado. Opcional.",
      )
      .nullish(),
    releasedDays: z
      .number()
      .int()
      .describe(
        "Número de dias a partir da data de início em que o acesso estará liberado. Opcional.",
      )
      .nullish(),
  }) as unknown as ToZod<CourseRegistrationSaveCourseAccessRequestViewModel>;
